import * as types from '../mutation-types'

const moduleIdPedido = {
	state: {
        idPedido: '',
	},
	getters: {
        idPedido: state => { return state.idPedido },
	},
	mutations: {
        [types.ADD_IDPEDIDO](state, idPedido) { state.idPedido = idPedido },
	},
	actions: {
		addIdPedido({ commit }, idPedido) {
			commit(types.ADD_IDPEDIDO, idPedido)
		},
	},
}
export default moduleIdPedido